import { Dialog, DialogContent } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  open: boolean;
  onClose?: (event: any, reason: 'backdropClick' | 'escapeKeyDown') => void;
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  fullWidth?: boolean;
}

export const QcsDialog: FC<Props> = ({
  className,
  open,
  onClose,
  children,
  maxWidth,
  fullWidth,
}) => {
  return (
    <Dialog
      className={className}
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogContent style={{ padding: '1rem' }}>
      {children}
      </DialogContent>
    </Dialog>
  );
};
